// extracted by mini-css-extract-plugin
module.exports = {"vendors":"Vendors_vendors__1SLTa","more":"Vendors_more__1cx4Q"};